export { DiscountPromo } from './DiscountPromo';
